//! moment.js locale configuration
//! locale : slovak (sk)
/* eslint-disable */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? factory(require('../moment'))
    : typeof define === 'function' && define.amd
    ? define(['moment'], factory)
    : factory(global.moment);
})(this, function (moment) {
  'use strict';

  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      m: ['jedna minúta', 'jednej minúty'],
      h: ['jedna hodina', 'jednej hodiny'],
      d: ['jeden deň', 'jedného dňa'],
      dd: [number + ' dni', number + ' dní'],
      M: ['jeden mesiac', 'jedného mesiaca'],
      MM: [number + ' mesiace', number + ' mesiacov'],
      y: ['jeden rok', 'jedného roku'],
      yy: [number + ' roky', number + ' rokov']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
  }

  var sk = moment.defineLocale('sk', {
    months:
      'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
        '_'
      ),
    monthsShort: 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_'),
    weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat: {
      LT: 'H:mm',
      LTS: 'H:mm:ss',
      L: 'DD.MM.YYYY',
      LL: 'D. MMMM YYYY',
      LLL: 'D. MMMM YYYY H:mm',
      LLLL: 'dddd D. MMMM YYYY H:mm'
    },
    calendar: {
      sameDay: '[dnes o] LT',
      nextDay: '[zajtra o] LT',
      nextWeek: 'dddd [o] LT',
      lastDay: '[včera o] LT',
      lastWeek: '[minulý] dddd [o] LT',
      sameElse: 'L'
    },
    relativeTime: {
      future: 'za %s',
      past: 'pred %s',
      s: 'pár sekúnd',
      m: processRelativeTime,
      mm: '%d minút',
      h: processRelativeTime,
      hh: '%d hodín',
      d: processRelativeTime,
      dd: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    ordinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
      dow: 1, // Monday is the first day of the week
      doy: 4 // The week that contains Jan 4th is the first week of the year
    }
  });

  return sk;
  /* eslint-enable */
});
